import { Card, Descriptions, Typography } from 'antd';
import React from 'react';
import FilePreview from '../../../../../shared/file-preview/file-preview';
import {
  CasesIdentityVerificationSummaryContainerArchivedCaseSummaryActivityLogFieldsFragment,
  CasesIdentityVerificationSummaryContainerArchivedIdentityVerificationCaseSummaryCaseDetailsFieldsFragment,
  CasesIdentityVerificationSummaryContainerFileInfoFieldsFragment
} from '../../../../../../generated';
import { FormatDate } from '../../../../../../constants';
import { Country } from '../../../../../../types/country';
import { TransactionData, TransactionsLite } from '../../../../../shared/transactions/transactions-lite';
import { ActivityLogLite } from '../../../../../shared/activitylog-lite/activity-log-lite';
import { LegalCertification } from '../../../../../shared/legal_certification/legal-certification';

const { Title } = Typography;

interface SummaryProps {
  caseDetailsData: CasesIdentityVerificationSummaryContainerArchivedIdentityVerificationCaseSummaryCaseDetailsFieldsFragment;
  fileDetails: CasesIdentityVerificationSummaryContainerFileInfoFieldsFragment[];
  countryData: Country[];
  transactionData: TransactionData;
  activityData: CasesIdentityVerificationSummaryContainerArchivedCaseSummaryActivityLogFieldsFragment[];
}

export const Summary: React.FC<SummaryProps> = (props) => {
  // calculate total amount


  return (
    <div className="flex flex-col space-y-4">
      <div>
        <Card>
          <Title level={4} style={{ display: 'inline' }}>
            Applicant Provided Details
          </Title>
          <Title level={5}>Passport Details</Title>
          <Descriptions layout="vertical">
            <Descriptions.Item label="Passport Country">
              {props.caseDetailsData?.application?.passportDetails?.passportCountry
                ? props.countryData.find((country) => country.countryCode === props.caseDetailsData?.application?.passportDetails?.passportCountry)?.countryName
                : 'N/A'}
            </Descriptions.Item>
          </Descriptions>
          <Descriptions layout="vertical" column={3}>
            <Descriptions.Item label="Passport Issue Date">
              {props.caseDetailsData?.application?.passportDetails?.passportIssuedAt
                ? FormatDate(props.caseDetailsData?.application?.passportDetails?.passportIssuedAt)
                : 'N/A'}
            </Descriptions.Item>
            <Descriptions.Item label="Passport Expiry Date">
              {props.caseDetailsData?.application?.passportDetails?.passportExpiresAt
                ? FormatDate(props.caseDetailsData?.application?.passportDetails?.passportExpiresAt)
                : 'N/A'}
            </Descriptions.Item>
            <Descriptions.Item label="Passport Number">
              {props.caseDetailsData?.application?.passportDetails?.passportNumber ? props.caseDetailsData?.application?.passportDetails?.passportNumber : 'N/A'}
            </Descriptions.Item>
            <Descriptions.Item label="">
              <LegalCertification isIdCase={true} />
            </Descriptions.Item>
          </Descriptions>
          <br />
          <Title level={4} style={{ display: 'inline' }}>
            Affirmations
          </Title>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6 items-start w-full" style={{ marginTop: '10px' }}>
            <div className="flex flex-col space-y-6">
              <Title level={5}>Application</Title>
              <Descriptions title={undefined} layout="vertical" size="small" column={2} className="w-[400px]">
                <Descriptions.Item label="Completed By">
                  {props.caseDetailsData?.applicationReview?.affirmations?.audit?.completedBy?.displayName?.toString() ?? 'N/A'}
                </Descriptions.Item>
                <Descriptions.Item label="Result">{props.caseDetailsData?.applicationReview?.affirmations?.audit?.result ?? 'N/A'}</Descriptions.Item>
                <Descriptions.Item span={2}>&nbsp;</Descriptions.Item>
                <Descriptions.Item label="Completed At">{props.caseDetailsData?.applicationReview?.affirmations?.audit?.completedAt ? FormatDate(props.caseDetailsData?.applicationReview?.affirmations?.audit?.completedAt as string) : 'N/A'}</Descriptions.Item>
              </Descriptions>
            </div>
            <div className="flex flex-col space-y-6">
              <Title level={5}>Notary</Title>
              <Descriptions title={undefined} layout="vertical" size="small" column={2} className="w-[600px]">
                <Descriptions.Item label="Completed By">
                  {props.caseDetailsData?.applicationReview?.notaryAffirmations?.audit?.completedBy?.displayName?.toString() ?? 'N/A'}
                </Descriptions.Item>
                <Descriptions.Item label="Result">{props.caseDetailsData?.applicationReview?.notaryAffirmations?.audit?.result ?? 'N/A'}</Descriptions.Item>
                <Descriptions.Item span={2}>&nbsp;</Descriptions.Item>
                <Descriptions.Item label="Completed At">{props.caseDetailsData?.applicationReview?.notaryAffirmations?.audit?.completedAt ? FormatDate(props.caseDetailsData?.applicationReview?.notaryAffirmations?.audit?.completedAt as string) : 'N/A'}</Descriptions.Item>
              </Descriptions>
            </div>
          </div>
          <div className="flex space-x-48 w-1/2"></div>
          <br />
          <Title level={5}>Files</Title>
          <div className="flex space-x-6 gap-16" style={{ maxWidth: '150%', flex: '1 1 auto', flexWrap: 'wrap', padding: '20px' }}>
            {props.fileDetails &&
              props.fileDetails
                ?.filter((file) => !file?.name?.endsWith('.json'))
                .map((file) => <FilePreview key={file?.name} fileUrl={file?.url || ''} fileName={file?.name?.split('/').pop() || ''} fileType={file?.type || ''} />)}
          </div>
        </Card>
        <br />
        <Card>
          <Title level={4}>Transaction Summary</Title>
          <TransactionsLite data={props.transactionData} />
          <Title style={{ marginTop: 20 }} level={4}>
            Activity Log
          </Title>
          <ActivityLogLite data={props.activityData} />
        </Card>
      </div>
    </div>
  );
};
